const MODULE = 'VACCINATION_RECORD';

export const GET_VACCINATION_RECORD = `${MODULE}/get_vaccination_record`;
export const GOT_VACCINATION_RECORD = `${MODULE}/got_vaccination_record`;
export const FORM_DATA = `${MODULE}/form_data`;
export const CLEAR_FORM_DATA = `${MODULE}/clear_form_data`;
export const CREATE = `${MODULE}/create`;
export const UPDATE = `${MODULE}/update`;
export const REMOVE = `${MODULE}/remove`;
